import React, { Component } from 'react';
import { Button, Input } from 'semantic-ui-react';
import API_Backend_Root from "../../Constants/API_Backend_Root";

class APIKeysIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null,
            accessKey: null,
            secretKey: null,
            showAccessKey: false,
            showSecretKey: false,
            copiedKey: null,
            regenerating: false  // Add this
        };
    }

    componentDidMount() {
        this.fetchAccountKeys();
    }

    fetchAccountKeys = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                this.setState({ 
                    error: "User authentication not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "fetch-account-keys/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userEmail,
                    token: userToken,
                    env: localStorage.getItem("env")
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    accessKey: data.access_key,
                    secretKey: data.secret_key,
                    loading: false
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch account keys",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching account keys:', error);
            this.setState({ 
                error: "Network error while fetching account keys",
                loading: false 
            });
        }
    }

    toggleAccessKey = () => {
        this.setState(prevState => ({
            showAccessKey: !prevState.showAccessKey
        }));
    }

    toggleSecretKey = () => {
        this.setState(prevState => ({
            showSecretKey: !prevState.showSecretKey
        }));
    }

    copyToClipboard = async (text, keyType) => {
        try {
            await navigator.clipboard.writeText(text);
            this.setState({ copiedKey: keyType });
            setTimeout(() => {
                this.setState({ copiedKey: null });
            }, 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    regenerateKeys = async () => {
        try {
            this.setState({ regenerating: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    regenerating: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "regenerate-account-keys/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({
                    email: localStorage.getItem("email"),
                    token: localStorage.getItem("token"),
                    env: localStorage.getItem("env")
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    accessKey: data.access_key,
                    secretKey: data.secret_key,
                    showAccessKey: false,
                    showSecretKey: false,
                    regenerating: false
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to regenerate keys",
                    regenerating: false 
                });
            }
        } catch (error) {
            console.error('Error regenerating keys:', error);
            this.setState({ 
                error: "Network error while regenerating keys",
                regenerating: false 
            });
        }
    }

    render() {
        const { loading, error, accessKey, secretKey, showAccessKey, showSecretKey, copiedKey } = this.state;

        if (loading) {
            return (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <div>Loading API keys...</div>
                </div>
            );
        }

        if (error) {
            return (
                <div style={{ 
                    backgroundColor: '#ffebee', 
                    color: '#c62828', 
                    padding: '12px', 
                    borderRadius: '4px', 
                    marginBottom: '20px' 
                }}>
                    Error: {error}
                </div>
            );
        }

        return (
            <div style={{ textAlign: 'left', width: '100%', margin: '0 auto', borderRadius: '4px', border: '1px solid #eee', padding: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0, color: '#333' }}>API Keys</h3>
                    <Button
                        onClick={this.regenerateKeys}
                        loading={this.state.regenerating}
                        disabled={this.state.regenerating}
                        style={{
                            backgroundColor: '#70BB98',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '10px 16px',
                            fontSize: '14px',
                            
                        }}
                    >
                        {this.state.regenerating ? 'Regenerating...' : 'Regenerate Keys'}
                    </Button>
                </div>
                
                {/* Access Key */}
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ 
                        display: 'block', 
                        fontWeight: '500', 
                        marginBottom: '8px',
                        color: '#333'
                    }}>
                        Access Key
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%', gap: '10px' }}>
                        <Input
                            fluid
                            readOnly
                            value={showAccessKey ? accessKey : "••••••••••••••••••••••••••••••••"}
                            style={{
                                fontFamily: 'monospace',
                                fontSize: '14px',
                                width: '600px'
                            }}
                            action={{
                                icon: showAccessKey ? 'eye slash' : 'eye',
                                onClick: this.toggleAccessKey,
                                color: showAccessKey ? 'red' : '#333'
                            }}
                        />
                        {showAccessKey && (
                            <Button
                                style={{
                                    backgroundColor: copiedKey === 'access' ? '#28a745' : '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '8px 10px',
                                    fontSize: '12px'
                                }}
                                onClick={() => this.copyToClipboard(accessKey, 'access')}
                            >
                                {copiedKey === 'access' ? 'Copied!' : 'Copy'}
                            </Button>
                        )}
                    </div>
                </div>

                {/* Secret Key */}
                <div style={{ marginBottom: '20px' }}>
                    <label style={{ 
                        display: 'block', 
                        fontWeight: '500', 
                        marginBottom: '8px',
                        color: '#333'
                    }}>
                        Secret Key
                    </label>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%', gap: '10px' }}>
                        <Input
                            fluid
                            readOnly
                            value={showSecretKey ? secretKey : "••••••••••••••••••••••••••••••••"}
                            style={{
                                fontFamily: 'monospace',
                                fontSize: '14px',
                                width: '600px'
                            }}
                            action={{
                                icon: showSecretKey ? 'eye slash' : 'eye',
                                onClick: this.toggleSecretKey,
                                color: showSecretKey ? 'red' : '#eee'
                            }}
                        />
                        {showSecretKey && (
                            <Button
                                style={{
                                    backgroundColor: copiedKey === 'secret' ? '#28a745' : '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    padding: '8px 10px',
                                    fontSize: '12px'
                                }}
                                onClick={() => this.copyToClipboard(secretKey, 'secret')}
                            >
                                {copiedKey === 'secret' ? 'Copied!' : 'Copy'}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default APIKeysIndex;
